var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.49994 10.992H19.0999L13.7959 5.712C13.6599 5.542 13.5779 5.324 13.5779 5.086C13.5779 4.529 14.0289 4.078 14.5859 4.078C14.8229 4.078 15.0419 4.16 15.2139 4.297L15.2119 4.295L22.2199 11.279C22.3019 11.374 22.3669 11.485 22.4099 11.608L22.4119 11.615C22.4659 11.728 22.4969 11.86 22.4969 11.999C22.4969 12.138 22.4659 12.27 22.4099 12.389L22.4119 12.383C22.3669 12.513 22.3019 12.624 22.2189 12.72L22.2199 12.719L15.2119 19.703C15.0299 19.881 14.7809 19.991 14.5059 19.991C14.5009 19.991 14.4959 19.991 14.4909 19.991H14.4919C14.2209 19.988 13.9749 19.879 13.7959 19.703C13.6159 19.521 13.5049 19.271 13.5049 18.995C13.5049 18.719 13.6159 18.469 13.7959 18.287L19.0999 13.007H3.49994C2.94294 13.007 2.49194 12.556 2.49194 11.999C2.49194 11.442 2.94294 10.991 3.49994 10.991V10.992Z",
    fill: "#1155CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.26e160ef43be84ad775f848f623b7b35.svg";
export { ForwardRef as ReactComponent };